import { createAction } from '@reduxjs/toolkit'
import type {
  ProjectAccess,
  ProjectMeta,
  ProjectSpace,
} from '@store/reducers/manager/meta/types'

import type { Member, Recipient } from '@/types'

type UpdateAccessPayload = ProjectAccess

type UpdateAvatarPayload = {
  avatar: string | null
}

type UpdateMemberPermissionPayload = {
  memberId: string
  permission: string
}

type UpdateUpdatedAtPayload = Pick<ProjectMeta, 'updatedAt'>

export const metaActions = {
  updateMeta: createAction<Partial<ProjectMeta>>('PROJECT_META_UPDATE'), // @todo remove
  updateAccess: createAction<UpdateAccessPayload>('PROJECT_META_ACCESS_UPDATE'),
  updateAvatar: createAction<UpdateAvatarPayload>('PROJECT_META_AVATAR_UPDATE'),
  updateUpdatedAt: createAction<UpdateUpdatedAtPayload>(
    'PROJECT_META_UPDATED_AT_UPDATE'
  ),
  addMember: createAction<Member>('PROJECT_META_MEMBER_ADD'),
  deleteMember: createAction<string>('PROJECT_META_MEMBER_DELETE'),
  updateMembers: createAction<Member[]>('PROJECT_META_MEMBERS_UPDATE'),
  updateMemberPermission: createAction<UpdateMemberPermissionPayload>(
    'PROJECT_META_MEMBER_PERMISSION_UPDATE'
  ),
  deleteMemberInvitation: createAction<string>(
    'PROJECT_META_DELETE_MEMBER_INVITATION'
  ),
  addRecipient: createAction<Recipient>('PROJECT_META_ADD_RECIPIENT'),
  setSpace: createAction<ProjectSpace>('PROJECT_META_SET_SPACE'),
}
